"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPANDED_THEME_VALUES = void 0;
var EXPANDED_THEME_VALUES;
(function (EXPANDED_THEME_VALUES) {
    EXPANDED_THEME_VALUES[EXPANDED_THEME_VALUES["DARK"] = 1] = "DARK";
    EXPANDED_THEME_VALUES[EXPANDED_THEME_VALUES["LIGHT"] = 2] = "LIGHT";
})(EXPANDED_THEME_VALUES = exports.EXPANDED_THEME_VALUES || (exports.EXPANDED_THEME_VALUES = {}));
//# sourceMappingURL=expanded-theme.js.map